/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import LceCourseExperience from 'bundles/epic/data/defaults/LceCourseExperience.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  isCourseFramePhase3Enabled: boolean;
  CourseFramePhase3StartDate: string;
  isFrameM4Enabled: boolean;
  is2026CourseFrameStylesEnabled: boolean;
  isToolPanelEnabled: boolean;
  isCourseFrameRevertToPhase1Enabled: boolean;
  showLessonsInOutline: boolean;
  isActivityInjectionEnabled: boolean;
  practiceMoment: 'control' | 'static' | 'interactive';
};

const NAMESPACE = 'LceCourseExperience';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([LceCourseExperience as $TSFixMe]);

const LceCourseExperienceEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default LceCourseExperienceEpicClient;
